module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"end":"Ende","link":"Link","location":"Ort","onlineEvent":"Online-Veranstaltung","registrationPeriod":"Anmeldefrist","slots":"Plätze","start":"Beginn"},"en":{"end":"End","link":"Link","location":"Location","onlineEvent":"Online event","registrationPeriod":"Registration period","slots":"Slots","start":"Start"}}')
  delete Component.options._Ctor
}
